export const exhaustiveTypeCheck = (params: never) => console.error(`Необходимо добавить обработку ${params}`);

export const getObjectKeysWithType = <E>(object: object) => Object.keys(object) as unknown as Array<E>;
